import { map } from "lodash";
import React, { useState } from "react";
import Icon from "react-icons-kit";
import { arrowRight, chevronDown, chevronUp } from "react-icons-kit/feather";
import {
  Badge,
  Button,
  Col,
  Collapse,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText,
  Row,
} from "reactstrap";
import { getStatus } from "../../helpers/status";
import "../../styles/List.scss";

const Status = ({ status }: { status: IListItemStatus }) => {
  return <Badge color={status.color}>{status.label}</Badge>;
};

const Item = ({
  item,
  index,
  onItemClick,
}: {
  item: ICollapsibleListItem;
  index: number;
  onItemClick: (item: ICollapsibleListItem) => void;
}) => {
  const status = getStatus(item.status);
  return (
    <ListGroupItem
      className="justify-content-between"
      key={`list-item-${index}`}
    >
      <Row className="collapse-list-item">
        <Col xs={6}>
          <ListGroupItemHeading>
            <strong>{item.title}</strong>
          </ListGroupItemHeading>
          <ListGroupItemText>{item.description}</ListGroupItemText>
        </Col>
        <Col className="text-center">
          {status ? <Status status={status} /> : null}
        </Col>
        <Col className="text-right">
          <Button
            onClick={() => onItemClick(item)}
            outline
            color={status ? status.color : "default"}
          >
            <Icon icon={arrowRight} style={{ marginBottom: "2px" }} />
          </Button>
        </Col>
      </Row>
    </ListGroupItem>
  );
};

const CollapsibleList: React.FC<PropertyGroupCollapsibleListProps> = (
  props: PropertyGroupCollapsibleListProps
) => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <div>
      <ListGroup>
        <ListGroupItem
          className="justify-content-between"
          onClick={() => setOpen(!open)}
        >
          <Row>
            {props.icon && <Icon icon={props.icon} size={32} />}
            <Col xs={6}>
              <strong>{props.title}</strong>
            </Col>
            {props.subTitle && (
              <Col className="text-center">
                <strong>{props.subTitle}</strong>
              </Col>
            )}
            <Col className="text-right">
              {props.collapse && <Icon icon={open ? chevronUp : chevronDown} />}
            </Col>
          </Row>
        </ListGroupItem>
        <Collapse isOpen={props.collapse ? open : true}>
          {map(props.items, (item, index) => {
            return (
              <Item
                key={item.id}
                item={item}
                index={index}
                onItemClick={props.onItemClick}
              />
            );
          })}
        </Collapse>
      </ListGroup>
    </div>
  );
};

export default CollapsibleList;
